
export default function Footer() {
    return (
        <footer className="text-center bg-dark text-white p-2">
            <h6>copyright Francisco Campos 2021 &nbsp;
            </h6>
        </footer>
    )
}